<!--
 * @Author: tony.zhu
 * @Date: 2025-09-26 10:59:15
 * @LastEditTime: 2025-10-15 18:43:51
 * @LastEditors: tony.zhu
 * @Description: 
-->

<template>
  <div class="c-question">
    <div class="question_wrap">
      <div class="question_wrap__left_wrap">
        <template>
          <div style="display: flex; justify-content: right">
            <div class="content_wrap">
              <!-- 内容渲染 -->
              <!-- 插槽类型渲染 -->
              <div v-for="(u, o) in data.content" :key="o">
                <template v-if="u.type == answerContentTypeEnum.Object.TEXT.code">
                  <span v-html="u.value || ''" style="white-space: pre-wrap; word-break: break-all" />
                </template>
                <template v-else>
                  <template v-for="(e, i) in answerContentTypeEnum.Array">
                    <slot
                      v-if="e.code !== answerContentTypeEnum.Object.TEXT.code"
                      :name="e.code + o"
                      :data="{ contentTypeData: e, params: data }"
                    />
                  </template>
                </template>
              </div>
              <p v-if="dataProp.tools && dataProp.tools.length > 0" style="font-style: italic;text-decoration: underline;">
                当前引用：
                <span v-for="(item, index) in dataProp.tools" :key="index"> {{ btnListConfig[item.type] }}； </span>
              </p>
            </div>
          </div>
          <!-- 图片显示区域 -->
          <div v-if="dataProp.images && dataProp.images.length > 0" class="images_wrap">
            <div v-for="(image, index) in dataProp.images" :key="index" class="image-item" @click="handleImageClick(image)">
              <IconFileType :fileName="image.name" class="file-icon" />
              <span class="image-name">{{ image.name }}</span>
            </div>
          </div>
          <div class="operate_wrap">
            <ActionsItem
              :dataProp="data"
              :indexProp="index"
              :formModalDataProp="formModalDataProp"
              v-on="$listeners"
              v-bind="$attrs"
            ></ActionsItem>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import ActionsItem from './actionsItem.vue'
import IconFileType from '@/views/talent/components/IconFileType.vue'
import { changeMappingHandle } from '@/components/aiChat/utils/tbox.js'
import { ANSWER_CONTENT_TYPE_ENUM } from '@/components/aiChat/common/notification.js'

export default {
  components: {
    ActionsItem,
    IconFileType
  },
  props: {
    dataProp: {
      type: Object,
      default() {
        return {}
      }
    },
    formModalDataProp: {
      type: Object,
      default() {
        return {}
      }
    },
    index: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      data: {},
      btnListConfig: {
        1: '原始简历',
        2: '标准简历',
        3: '测评结果',
        4: '面试录音',
        5: '录音文本',
        6: '工作职责',
        7: '任职资格',
        8: '职位名称',
        9: '职位画像',
      }
    }
  },
  computed: {
    answerContentTypeEnum() {
      return changeMappingHandle(ANSWER_CONTENT_TYPE_ENUM)
    }
  },
  methods: {
    handleImageClick(image) {
      this.$emit('open-image-preview', image)
    }
  },
  watch: {
    dataProp: {
      handler: function (n) {
        console.log(n, 'n')
        this.data = JSON.parse(JSON.stringify({ ...n }))
        if (this.data.content) {
          this.data.content.forEach(item => {
            item.value = item.value.replace(/\n/g, '<br/>')
          })
        }
      },
      immediate: true
    },
    data: {
      handler: function (n) {
        this.$emit('on-change-data', {
          ...this.dataProp,
          ...n
        })
      },
      deep: true
    }
  }
}
</script>

<style lang="scss" scoped>
.c-question {
  margin-bottom: 16px;
  .question_wrap {
    display: flex;
    align-items: center;
    align-items: flex-start;
    justify-content: flex-end;
    &__left_wrap {
      width: 100%;
      .content_wrap {
        border-radius: 8px 0px 8px 8px;
        background: #c5e5ff;
        padding: 12px 12px;
        font-size: 14px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        line-height: 20px;
        font-size: 14px;
        color: #1d2129;
        line-height: 22px;
      }
      .operate_wrap {
        margin-top: 4px;
        margin-right: 8px;
        min-height: 24px;
        z-index: 2;
        position: relative;
        ::v-deep .c-operate {
          opacity: 0;
          transition: opacity 0.3s;
        }
      }
      &:hover {
        ::v-deep .c-operate {
          opacity: 1;
          transition: opacity 0.3s;
        }
      }
    }
  }
}

.images_wrap {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 8px;
  margin-top: 8px;

  .image-item {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 8px;
    padding: 8px 12px;
    background: #f7f8fa;
    border-radius: 4px;
    border: 1px solid #e5e6eb;
    cursor: pointer;
    transition: background-color 0.2s;

    &:hover {
      background-color: #e8f3ff;
    }

    .file-icon {
      flex-shrink: 0;
      ::v-deep .icon-item {
        width: 24px;
        height: 24px;
        margin-right: 0;
      }
    }

    .image-name {
      font-size: 14px;
      color: #1d2129;
      max-width: 200px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
}
</style>
